import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
    clearSmartDeviceFormData,
    selectSmartDeviceForm,
    setSmartDeviceFormData
} from "../redux/features/smartDeviceFormSlice";

const useSmartDeviceFormData = (formName, setFormData) => {
    const dispatch = useDispatch();
    const smartDeviceFormData = useSelector(selectSmartDeviceForm);
    const redux_form_data = smartDeviceFormData?.[formName];

    useEffect(() => {
        if (redux_form_data) {
            setFormData(redux_form_data);
        }
    }, []);

    const saveSmartDeviceDataInRedux = async (formData) => {
        return new Promise((resolve, reject) => {
            try {
                dispatch(setSmartDeviceFormData({ form_name: formName, data: formData }));
                resolve();
            } catch (error) {
                reject(error);
            }
        });
    };

    const removeSmartDeviceFormData = () => {
        dispatch(clearSmartDeviceFormData({ form_name: formName }));
    };

    return {
        saveSmartDeviceDataInRedux,
        removeSmartDeviceFormData,
        redux_form_data
    };
};

export default useSmartDeviceFormData;
